(function () {
    var COOKIE_DOMAIN = '.lazydogrestaurants.com';
    var COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90; // 90 days, aligned with _fbc
    var CLICK_IDS = ['ttclid', 'msclkid'];

    function isLazyDogHost() {
      var host = window.location.hostname;
      return host === 'lazydogrestaurants.com' || host.endsWith('.lazydogrestaurants.com');
    }

    function writeCookie(name, value) {
      document.cookie = [
        name + '=' + encodeURIComponent(value),
        'Domain=' + COOKIE_DOMAIN,
        'Path=/',
        'Max-Age=' + COOKIE_MAX_AGE_SECONDS,
        'Secure',
        'SameSite=Lax'
      ].join('; ');
    }

    function hasAnalyticsConsent() {
      try { return window.Termly && window.Termly.getConsentState().analytics === true; }
      catch (e) { return false; }
    }

    function readUrlClickIds() {
      var params = new URLSearchParams(window.location.search);
      var found = {};
      for (var i = 0; i < CLICK_IDS.length; i++) {
        var v = params.get(CLICK_IDS[i]);
        if (v) found[CLICK_IDS[i]] = v;
      }
      return found;
    }

    var captured = false;
    function tryCapture() {
      if (captured) return;
      if (!hasAnalyticsConsent()) return;
      if (!isLazyDogHost()) return; // skip myshopify preview / unknown host
      var found = readUrlClickIds();
      var keys = Object.keys(found);
      if (keys.length === 0) { captured = true; return; } // nothing on this landing
      for (var i = 0; i < keys.length; i++) writeCookie(keys[i], found[keys[i]]);
      // Also push to dataLayer so Shopify-side tags can use them on this landing
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(found);
      captured = true;
    }

    function attach() {
      tryCapture();
      if (window.Termly && typeof window.Termly.on === 'function') {
        window.Termly.on('consent', tryCapture);
      }
    }

    if (window.Termly) {
      attach();
    } else {
      var observer = new MutationObserver(function () {
        if (window.Termly) { observer.disconnect(); attach(); }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();